import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { GetUsersThunk, numberUsersByPage } from '../../../../../redux/slices/components/ManageUsers/manageUsersDataSlice';
import { RootState, useAppDispatch } from '../../../../../redux/store/store';
import { getPaginatedData } from '../../../../../utils/strings/strings';
import { useNavigate } from 'react-router-dom';

const PaginationUserTable = () => {

    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    
    const { usersToShow, loadingContainer, page, limit, total } = useSelector((state: RootState) => state.manageUsersData);
    const isLastPage = total - (limit * page) <= 0 ? true : false 

    const paginate = (direction: string) => {
        
        if(loadingContainer)
            return
        
        if(direction === "forward"){
            navigate(`/manage-users?limit=${limit}&page=${page + 1}`)
        }
        else if(direction === "backward" && page !== 1){
            navigate(`/manage-users?limit=${limit}&page=${page - 1}`)
        }

    }

    const changeNumberOfPages = (newNumberOfPages: number) => {
        const totalOffersUntilNow = (page - 1) * limit + usersToShow.length 
        if(newNumberOfPages > totalOffersUntilNow){
                dispatch(GetUsersThunk({ page: 1, limit: newNumberOfPages }))
        }else{
                dispatch(GetUsersThunk({ page: 1, limit: newNumberOfPages }))
        }
    }


    return (
        <div className="con-row-pagination flex flex-jc-end flex-ai-center mr-20 ff-roboto">
         
            <div className=""></div>
            
            <div className="flex flex-ai-center">
                <button 
                    onClick={() => paginate("backward")} 
                    className={`fs-20 mr-12 ${(page === 1)?  "disable-color" : "c-black pointer"}`}
                    disabled={(page === 1 || loadingContainer ) ? true : false} 
                >
                    <FontAwesomeIcon icon={solid("arrow-left-long")}  />
                </button>
                <p className="fs-15 fw-700">{page}</p>
                <button 
                    onClick={() => paginate("forward")}  
                    className={`fs-20 ml-12 ${( isLastPage) ?  "disable-color" : "c-black pointer"}`}
                    disabled={( isLastPage || loadingContainer ) ? true : false}
                >
                    <FontAwesomeIcon icon={solid("arrow-right-long")}  />
                </button>
            </div>
            
            <div className="flex ml-20">
                {
                    numberUsersByPage.map((numberPages: number, index: number) => {
                        return (
                            <button 
                                key={index}
                                disabled={numberPages === limit || loadingContainer}
                                className={`fs-14 fw-500 mr-12 ${numberPages === limit ? "c-black" : "disable-color pointer"}`}
                                onClick={() => { 
                                    //if(indexTab > 0)
                                        changeNumberOfPages(numberPages) 
                                    //else
                                        //changeNumberOfPagesSearchBar(numberPages)
                                }}
                            >
                                {numberPages === -1 ? t("Reports:user:label_04") : numberPages}
                            </button>
                        )
                    })
                }
                <p className="fw-500 fs-14 ml-10">
                    {`${getPaginatedData(page, limit, total)} ${t("General:label_267")} ${total}`}
                </p>
            </div>

        </div>
    )
}

export default React.memo( PaginationUserTable )